import { Props as SelectProps } from "react-select";
import { SelectComponent } from "@/components/SelectComponent";

type Props = SelectProps;

export const defaultGender = { value: "", label: "Todos" };

export function GenderSelect({ ...rest }: Props) {
	const options = [
		{ value: "", label: "Todos" },
		{ value: "M", label: "Masculino" },
		{ value: "F", label: "Feminino" },
	];
	
	return (
		<SelectComponent
			className="fs-8 p-0"
			inputId="gender"
			placeholder="Selecione..."
			noOptionsMessage={() => "Nenhuma opção encontrada"}
			options={options}
			{...rest}
		/>
	);
}
